import React from 'react';
  import axios2 from 'services/axios2';

  import {useParams} from 'react-router-dom';
  import {Link,hashHistory} from 'react-router-dom';
  import { ToastContainer, toast } from 'react-toastify';
  import NuDropdown from "../../../components/nubox/NuDropdown";

  import { withRouterJim } from "router/withRouterJim";
  import NuConfirm from "components/nubox/Box/NuConfirm";
  import ModalCategoria from './ModalCategoria'

  import user from 'assets/img/user.jpg';

  import { NotificationContainer, NotificationManager } from 'react-notifications';
  import {
    Table,
    Button,
  } from 'reactstrap';

  const data = [
    //{ id_medico: 1,  nombre: 'ALEX LIZARRAGA',  especialidad: '00000023',tel:''}, 
  ];
  /*$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$*/
  class CategoriaList extends React.Component {  
  
    modalRef = React.createRef();//create ref
    
    state = {
      modalInsertar: false,
      form: {
        name: '',
        id_carre:0,
      },
      data: data,/* lista de datos */
      carreras:[],
    };
     //--------------------------------------
  constructor(props) {
    super(props);

    this.refNuConfirm = React.createRef();
  }
  //------------------
    //------------------------------------------------------
    componentDidMount() {
      //--limpiamos el array de datos
      this.setState({data:[]});

      this.cargar_data();
      this.cargar_carreras();
      //this.cargar_citas();
      console.log(this.modalRef);
    }
    //----------------especial, actualiza valores del form -------------------------------
    handleChangeForm = (e) => {
      //requerimos la prop name='?' en cada control
      this.setState({
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      });
    };
    //====================================================== 
    cargar_data = () => {
      let param = { 
        key: this.state.form.name,
        id_carre: this.state.form.id_carre
      }
      
      console.log(param);
      axios2.post( 'categoria_get_list', param)
      .then(res => {
      
          if(res.data.length>0){ 
              this.setState({data: res.data});
          }else{
              this.setState({data: []});
              NotificationManager.error('No existen datos');
          }
  
      }).catch(error => {
          alert('---- Existio un error ---');
          console.log(error);
          
      });
    };
    //======================================================
    cargar_carreras = async() => {
      let param = { }
      await axios2.post("cbo_carrera", param).then(res => {
          if(res.data.length>0){ 
              this.setState({carreras: res.data});
          }else{
            toast.error("No existen datos");
          }
      }).catch(error => {
          alert("---- Existio un error ---");
          console.log(error);
          
      });
    };
    
    //======================================================     
    imprimir =(id_certi)=>{
      let fileURL = process.env.REACT_APP_API_URL  + 'certificado_reciboPDF/'+ id_certi;
      let  windowFeatures = 'width=650,height= 700, left=100,top=100 ';
      window.open(fileURL,'',windowFeatures);
    }
    /* === This is where the magic happens ==== */
    /* === antes de enviar el formulario ====== */
    handleSubmit = event => {
      event.preventDefault();
      this.cargar_data();
    }
    //-----------------------------------------------------------------
    nuevo = () => {
      this.modalRef.current.nuevo();
    }
    //-----------------------------------------------------------------
    editar = (item) =>{
      console.log('editar');
      //    console.log(item);
      let idd = item.id_cate;
      this.modalRef.current.editar(idd);
    }
    //-----------------------------------------------------------------
    eliminar = (item) =>{
      console.log('eliminar');
      
      this.refNuConfirm.current.show({
        message: 'Esta seguro de eliminar?',
        title: 'Confirmar',
        icon: 'fa fa-question-circle',
        classHeader: 'bg-default1 ',
        classButton: 'btn btn-danger',
        accept: () => {
          let idd = item.id_cate;
          this.modalRef.current.eliminar(idd);
        },
        reject: () => {
            console.log('cancel');
        },
        acceptLabel: 'Aceptar',
        rejectLabel: 'Cancelar'
      })
  
    }
    //-------------------------------------
    okModal =()=>{
      console.log('citaOkModal');
      this.cargar_data();
    }
    //-------------------------------------
    closeModal =()=>{
      console.log('citaCancelModal');
    }
    //-------------------------------------
    render() {
    
      return (
        <div>
          <ToastContainer />
          <div className='content'>
  
            {/*{/*--- -----------------------------*/}
            <div className='row'>
              <div className='col-md-12'>
                <h3> Lista de categorias
                    
                </h3>
  
  
                <div className='box box-info' style={{ width: 350 }}>
                  {/*-- box-header --*/}
                  <div className='box-body pad'>
  
                    <form onSubmit={this.handleSubmit}>
  
                     
  
                        
                          <table className='tabla_basic'>
                            <tbody>
                              <tr>
                                <td>Nombre</td>
                                <td >
                                  <input 
                                    type='text' 
                                    name='name' 
                                    onChange={this.handleChangeForm} 
                                    className='form-control input-sm' />
                                </td>
                                <td rowSpan={2} >
                                  <button type='submit' style={{ marginTop: '24px' }} 
                                          className='btn btn-success '>
                                  <i className='fa fa-binoculars'></i> Buscar</button>
                                </td>
                              </tr>
                              <tr>
                                <td>Carrera:</td>
                                <td >
                                <NuDropdown
                                    options={this.state.carreras}
                                    
                                    name="id_carre"
                                    value={this.state.form.id_carre}
                                    onChange={this.handleChangeForm}
                                />
                                </td> 
                                <td></td>
                              </tr>

                              
                              <tr>
                                <td colspan="3"><div id="divres1"></div></td>
                              </tr>
                            </tbody>
                          </table>
                          
                       
  
                        
                          
  
                        
  
                      
                    </form>
  
                  </div>
                  {/* box-body */}
                </div>
  
  
                {/*-- box table */}
                <div className='box'>
  
                  <div className='box-body'>
                    <div className='top_title2'>
                      <div className='row'>
                        <div className='col-md-12'>
                          
                        
                          <div className=' pull-right'>
  
                            <Button onClick={() => this.nuevo()} 
                              className='create-modal btn btn-info ' >
                              <i className='fa fa-plus'></i> Nuevo 
                            </Button>
                          </div>
                          <h4>categoria</h4>
                        </div>
                      </div>
                    </div>
                    {/*-- */}
                    <table className='table table-striped table-hover' width='100%' align='center'>
                      <thead>
    
                        <tr>
                        <th>Cod cate</th>
                        <th>Carrera</th>
                        <th>Categoria</th>

                        <th>Accion</th>
                        </tr>
  
                      </thead>
                      <tbody>
                        {/* className='text-left' */}
                        
                        {this.state.data.map((item, index) => (
                          <tr key={index}> 
                            <td>{ item.id_cate }</td>
                            <td>{ item.nombreca }</td>
                            <td>{ item.nombrec }</td>

                            <td>
                              <div className='btn-group'>
                                <Button className='btn btn-warning btn-sm' title='Editar' 
                                  onClick={() => this.editar(item)}>
                                  <i className='fa fa-edit'></i>
                                </Button>
                                &nbsp;
                                <Button className='btn btn-danger btn-sm' title='Eliminar' 
                                  onClick={() => this.eliminar(item)}  >
                                  <i className='fa fa-trash'></i>
                                </Button>
                              </div>
                            </td>
                          </tr>
                        ))}
  
  
  
                      </tbody>
                    </table>
                    {/*-- */}
                  </div>
  

                  <ModalCategoria
                    ref={this.modalRef}
                    okModal={this.okModal}
                    closeModal={this.closeModal}
                  />
  
                </div>
              </div>
            </div>
          </div>
          
          <NotificationContainer/>
          <NuConfirm   ref={ this.refNuConfirm }    />
        </div>
      );
    }
  }
  //------------para que soporte la funcionalidad de parametros
 
  export default withRouterJim(CategoriaList);
  